import { noticeDispatch } from '@api/announcement';
import ZeissButton from '@components/button';
import { ROLE_KEYS_MAP } from '@constants';
import { DataFlagEnum } from '@views/pages/AnnouncementList/announcement';
import { sectorValueMap } from '@views/pages/AnnouncementList/tool';
import { Form, Modal, Space, message } from 'antd';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDealerForm } from '../Form/useDealerForm';
import { useRepeatForm } from '../Form/useRepeatForm';
import { baseSectorTypeNameList, useSalesForm } from '../Form/useSalesForm';
import { useTransferForm } from '../Form/useTransferForm';
import { useUnrelatedForm } from '../Form/useUnrelatedForm';
import { FOOTER_POPUP_ACTION } from '../type';
import './annFooterPopup.scss';
// 导出一个名为AnnFooterPopup的函数组件
const dealerSectorArr = ['4', '5', '6'];
export const AnnFooterPopup = ({
  // 取消按钮文本，默认为'取消'
  cancelText = '取消',
  // 确认按钮文本，默认为'确认'
  confirmText = '确认',
  // 操作ID，默认为-1
  actionId = -1,
  // 通知代码
  noticeCode = '',
  // 详情
  details = {},
  // 确认回调函数
  confirmCallback,
  // 是否不相关
  unrelatedTip = false,
  open = false,
  // 经销商公司ID
  setOpen = () => {},
  isAnnouncement = false,
  isDispatchAll = false
}: // 设置打开状态的函数
any) => {
  const { userInfo } = JSON.parse(
    // 从localStorage中获取recoil-persist的值，并解析为JSON对象
    localStorage.getItem('recoil-persist') || '{}'
  );

  const isSales = userInfo?.roleKeys === ROLE_KEYS_MAP.sales;
  // const isDealer = userInfo?.roleKeys === ROLE_KEYS_MAP.dealer;

  // 判断用户角色是否为销售
  const [form] = Form.useForm();
  // 使用Form组件创建表单
  const { repeatForm } = useRepeatForm(
    isSales && details.dataFlag === DataFlagEnum.dealer
  );
  const { unrelatedForm } = useUnrelatedForm(
    unrelatedTip,
    details,
    isAnnouncement
  );
  const { transferForm } = useTransferForm({
    form,
    isAdmin: userInfo?.roleKeys === 'admin',
    open
  });
  const { salesForm } = useSalesForm({
    details,
    form,
    backUpRequired_N: true,
    open
  });
  const { dealerForm } = useDealerForm({
    details,
    form,
    backUpRequired_N: true,
    open
  });
  const navigate = useNavigate();

  const renderForm = () => {
    let dom = null;
    //3:转销售 2:转Sector同事 5:不相关 6:重复
    switch (actionId) {
      case 3:
        dom = salesForm;
        break;
      case 2:
        dom = transferForm;
        break;
      case 5:
        dom = unrelatedForm;
        break;
      case 6:
        dom = repeatForm;
        break;
      case 8:
        dom = dealerForm;
        break;
      default:
        dom = '';
    }
    return dom;
  };

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  const onFinish = async (val: any) => {
    if (confirmCallback) {
      const sectorKey = baseSectorTypeNameList.find(
        (v) => v.key === val.sector
      )?.value;
      confirmCallback({
        ...val,
        sectorKey
      });
      setOpen(false);
    } else {
      if (actionId === 2) {
        //2 :转Sector同事
        if (val.frontEndRemarks) {
          await noticeDispatch({
            ...val,
            dispatchUserId: val.frontEndRemarks.dispatchUserId,
            dispatchUserName: val.frontEndRemarks.dispatchUserName,
            noticeCode,
            action: actionId,
            dataFlag: details.dataFlag,
            dispatchAll: isDispatchAll
          });
        } else {
          return message.warning('请先选择一名人员');
        }
      } else if (actionId === 5 || actionId === 6) {
        //5 : 不相关 6:重复
        const user_local = JSON.parse(
          localStorage.getItem('recoil-persist') || '{}'
        );
        const options = {
          ...val,
          dispatchUserId: user_local.userInfo.userId,
          dispatchUserName: user_local.userInfo.realName,
          noticeCode,
          action: actionId,
          dataFlag: details.dataFlag,
          unrelatedReason: '',
          unrelatedReasonValue: '',
          dispatchAll: isDispatchAll
        };
        if (val?.unrelatedReason) {
          const unrelatedReasonItem = val.unrelatedReason?.split('-');
          const reason = unrelatedReasonItem.slice(1).join('-');
          options.unrelatedReason = unrelatedReasonItem[0];
          options.unrelatedReasonValue = reason;
          options.recordRemark = val.recordRemark
            ? `${reason}：${val.recordRemark}`
            : reason;
        }
        await noticeDispatch(options);
      } else {
        const userInfo = val.sales && val.sales.split('-');

        const { sector } = val;

        const curDataFlag = dealerSectorArr.includes(sectorValueMap[sector])
          ? DataFlagEnum.dealer
          : DataFlagEnum.directSelling;

        await noticeDispatch({
          ...val,
          sectorType: sectorValueMap[sector],
          sectorTypeValue: sector,
          dispatchUserId: userInfo[0],
          dispatchUserName: userInfo[1],
          noticeCode,
          action: actionId,
          dataFlag: curDataFlag,
          dispatchAll: isDispatchAll
        });
      }
      setOpen(false);
      navigate('/announcement');
    }
    // getAnnInfo();
  };

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open, form]);

  return (
    <Modal
      width={520}
      open={open}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose={true}
      centered
    >
      <div className="pc-repeatPopup-layout">
        <div className="pc-repeatPopup-title">
          {userInfo?.roleKeys === 'admin' && actionId == 2
            ? '转交给Sector'
            : FOOTER_POPUP_ACTION[actionId]}
        </div>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          {renderForm()}
          <Space className="pc-repeatPopup-footer" size="middle">
            <ZeissButton className="pc-normal-btn" onClick={handleCancel}>
              {cancelText}
            </ZeissButton>
            <ZeissButton htmlType="submit" className="pc-confirm-btn">
              {confirmText}
            </ZeissButton>
          </Space>
        </Form>
      </div>
    </Modal>
  );
};
